import { generatePath } from 'react-router-dom'
import { VISUAL_STYLES_PLAYGROUND_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { PaintBucket2 } from 'blaze-ui/icons'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuVisualStylesPlaygroundItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={PaintBucket2}
      activeIcon={PaintBucket2}
      to={generatePath(VISUAL_STYLES_PLAYGROUND_PATH, { workspaceId })}
      onPress={onPress}
      label="Visual Styles Playground"
    />
  )
}

export { NavMenuVisualStylesPlaygroundItem }
